<template>
  <div>
    <h4 class="text-gray">
      <i class="linecons-tag" :id="transName(item)"></i><strong>{{transName(item)}}</strong>
    </h4>
    <div class="row">
      <div class="col-sm-3" v-for="(web, idx) in item.web" :key="idx">
        <div class="xe-widget xe-conversations box2 label-info" title=""
          @click="openweb(web.url, web.ref)"
          data-toggle="tooltip" 
          data-placement="bottom" 
          :data-original-title="web.private_url">

          <div class="xe-comment-entry">
            <a class="xe-user-img">
              <!-- img :src="web.logo" class="lozad img-circle" width="40" -->             
              <img :src="`https://www.google.com/s2/favicons?domain=${web.url}&sz=32`" />
            </a>
            <div class="xe-comment">
              <a href="#" class="xe-user-name overflowClip_1">
                <strong>{{web.title}}</strong>
              </a>
              <p class="overflowClip_2">{{web.desc}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  name: 'WebItem',
  props: {
    item: Object,
    transName: Function
  },
  methods: {
    openweb(url, ref) {
      window.open(url+ref, '_blank');
    },
    geticon(url) {
      return "https://www.google.com/s2/favicons?domain=" + url;
    }
  }
}
</script>

<style scoped>
i {
  margin-right: 7px;
}
</style>
